<template>
  <div id="app">
    <router-view />
    <Tab/>
  </div>
</template>
<script>
import Tab from '@/components/TabBar.vue'
export default {
  name: 'layout',
  components: {
    Tab
  },
  data () {
    return {
    }
  },
  computed: {

  },

  methods: {

  }
}
</script>
<style>
html,
body {
  height: 100%;
}
body {
  height: 100%;
  color: #333;
  line-height: 1;
  margin: 0;
}
#app {
  /* position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0; */
  width: 100%;
  line-height: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  user-select: none;
}

.container{
  width: 100%;
  display: flex;
  flex-direction: column;
}
.ellipsis2 {
  display: -webkit-box;
  word-break: break-all;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow:ellipsis;
}
</style>
